module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(!_vm.isKeToan) ? _c('v-content', [_c('router-view')], 1) : _c('v-content', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84cec67e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 723
// module chunks = 1